import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

//配置路由
const router = new Router({
  mode: "history",
  // mode: "hash",
  routes: [
    {
      path: "/",
      component: () => import("../views/HomeView.vue"),
    },
    {
      path: "/search",
      component: () => import("../views/search.vue"),
    },
    {
      path:'/xxgk',
      name: 'xxgk',
      component: () => import("@/views/xxgk/xxgk.vue"),
      redirect:{name: 'xxjj'},
      children: [
        {
          path:'xxjj',
          name:'xxjj',
          component:() => import("@/views/xxgk/xxjj.vue"),
        },
        {
          path:'xxln',
          name:'xxln',
          component:() => import("@/views/xxgk/xxln.vue"),
        },
        {
          path:'lsfc',
          name:'lsfc',
          component:() => import("@/views/xxgk/lsfc.vue"),
        },
        {
          path:'xzjy',
          name:'xzjy',
          component:() => import("@/views/xxgk/xzjy.vue"),
        },
        {
          path:'xxfzjs',
          name:'xxfzjs',
          component:() => import("@/views/xxgk/xxfzjs.vue"),
        },
        {
          path:'jxbjj',
          name:'jxbjj',
          component:() => import("@/views/xxgk/jxbjj.vue"),
        }
      ]
    },
    {
      path:'/jnds',
      name: 'jnds',
      component: () => import("@/views/jnds/jnds.vue"),
      redirect:{name: 'jnzy'},
      children: [
        {
          path:'jnzy',
          name:'jnzy',
          component:() => import("@/views/jnds/jnzy.vue"),
        },
        {
          path:'rjkfds',
          name:'rjkfds',
          component:() => import("@/views/jnds/rjkfds.vue"),
        },
        {
          path:'zzjnds',
          name:'zzjnds',
          component:() => import("@/views/jnds/zzjnds.vue"),
        },
        {
          path:'wgjygc',
          name:'wgjygc',
          component:() => import("@/views/jnds/wgjygc.vue"),
        },
        {
          path:'zjzx',
          name:'zjzx',
          component:() => import("@/views/jnds/zjzx.vue"),
        },
        {
          path:'qgxxjs',
          name:'qgxxjs',
          component:() => import("@/views/jnds/qgxxjs.vue"),
        },
        {
          path:'qgswszh',
          name:'qgswszh',
          component:() => import("@/views/jnds/qgswszh.vue"),
        }
      ]
    },
    {
      path:'/zyjs',
      name:'zyjs',
      redirect:{name: 'rjkf'},
      component:() => import("@/views/zyjs/zyjs.vue"),
      children:[
        {
          path:'rjkf',
          name:'rjkf',
          component:() => import("@/views/zyjs/rjkf.vue"),
        },
        {
          path:'qdkf',
          name:'qdkf',
          component:() => import("@/views/zyjs/qdkf.vue"),
        },
        {
          path:'wzkf',
          name:'wzkf',
          component:() => import("@/views/zyjs/wzkf.vue"),
        },
        {
          path:'pmsj',
          name:'pmsj',
          component:() => import("@/views/zyjs/pmsj.vue"),
        },
        {
          path:'cpjg',
          name:'cpjg',
          component:() => import("@/views/zyjs/cpjg.vue"),
        }
      ]
    },
    {
      path:'/jyycy',
      name:'jyycy',
      redirect:{name: 'hzqy'},
      component:() => import("@/views/jyycy/jyycy.vue"),
      children:[
        {
          path:'hzqy',
          name:'hzqy',
          component:() => import("@/views/jyycy/hzqy.vue"),
        },
        {
          path:'gzhj',
          name:'gzhj',
          component:() => import("@/views/jyycy/gzhj.vue"),
        },
        {
          path:'gzqk',
          name:'gzqk',
          component:() => import("@/views/jyycy/gzqk.vue"),
        },
        {
          path:'cyqk',
          name:'cyqk',
          component:() => import("@/views/jyycy/cyqk.vue"),
        }
      ]
    },
    {
      path: '/jngk',
      name:'jngk',
      component: () => import("@/views/jngk/jngk.vue")
    },
    {
      path: '/cjrh',
      name:'cjrh',
      component: () => import("@/views/cjrh/cjrh.vue")
    },
    {
      path: '/jyjl',
      name:'jyjl',
      component: () => import("@/views/jyjl/jyjl.vue")
    },
    {
      path: '/qcgs',
      name:'qcgs',
      redirect:{name: 'zcgs'},
      component: () => import("@/views/qcgs/qcgs.vue"),
      children:[
        {
          path:'zcgs',
          name:'zcgs',
          component:() => import("@/views/qcgs/zcgs.vue"),
        },
        {
          path:'xygs',
          name:'xygs',
          component:() => import("@/views/qcgs/xygs.vue"),
        }
      ]
    },
    {
      path: '/xyxw',
      name:'xyxw',
      redirect:{name: 'xxxw'},
      component: () => import("@/views/xyxw/xyxw.vue"),
      children:[
        {
          path:'xxxw',
          name:'xxxw',
          component:() => import("@/views/xyxw/xxxw.vue"),
        },
        {
          path:'mtbd',
          name:'mtbd',
          component:() => import("@/views/xyxw/mtbd.vue"),
        },
        {
          path:'ldgh',
          name:'ldgh',
          component:() => import("@/views/xyxw/ldgh.vue"),
        },
        {
          path:'jydt',
          name:'jydt',
          component:() => import("@/views/xyxw/jydt.vue"),
        },
        {
          path:'tzgg',
          name:'tzgg',
          component:() => import("@/views/xyxw/tzgg.vue"),
        }
      ]
    },
    {
      path: '/xysh',
      name:'xysh',
      redirect:{name: 'djyl'},
      component: () => import("@/views/xysh/xysh.vue"),
      children:[
        {
          path:'djyl',
          name:'djyl',
          component:() => import("@/views/xysh/djyl.vue"),
        },
        {
          path:'zyzx',
          name:'zyzx',
          component:() => import("@/views/xysh/zyzx.vue"),
        },
        {
          path:'xsh',
          name:'xsh',
          component:() => import("@/views/xysh/xsh.vue"),
        },
        {
          path:'wmbj',
          name:'wmbj',
          component:() => import("@/views/xysh/wmbj.vue"),
        },
        {
          path:'wthd',
          name:'wthd',
          component:() => import("@/views/xysh/wthd.vue"),
        },
        {
          path:'yj',
          name:'yj',
          component:() => import("@/views/xysh/yj.vue"),
        },
        {
          path:'lzjy',
          name:'lzjy',
          component:() => import("@/views/xysh/lzjy.vue"),
        },
        {
          path:'mhsj',
          name:'mhsj',
          component:() => import("@/views/xysh/mhsj.vue"),
        }
      ]
    },
    {
      path: '/zsrx',
      name:'zsrx',
      component: () => import("@/views/zsrx/zsrx.vue")
    },
    {
      path: '/detail/:id?',
      name:'xyxwDetail',
      component:() => import('@/views/xyxw/detail.vue')
    },
    {
      path: '/detail1/:id?',
      name:'xyxwDetail',
      component:() => import('@/views/xyxw/detail1.vue')
    },
    {
      path: '/detail2/:id?',
      name:'xyxwDetail',
      component:() => import('@/views/xyxw/detail2.vue')
    },
    {
      path: '/detail3/:id?',
      name:'jyjlDetail',
      component:() => import('@/views/jyjl/detail3.vue')
    },
    {
      path: '/qcgs/detail/:id?',
      name:'qcgsDetail',
      component:() => import('@/views/qcgs/detail.vue')
    },
    {
      path: '/xygs/detailSchool/:id?',
      name:'xygsDetail',
      component:() => import('@/views/qcgs/detailSchool.vue')
    }
  ],
});

//导出
export default router;
